import { ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { ObjectSelectInput, ObjectSelectProps } from '@frontend/components/basic-forms';
import { CommonMessage } from '@frontend/lang';
import { useAccountRepository } from '@frontend/repository';
import { StepClient } from '@frontend/wizard/api';
import { Step, StepListResponse, StepQueryParams } from '@frontend/wizard/types';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

const ID = 'step-select';
export interface StepSelectProps extends ObjectSelectProps<Step, StepQueryParams> {
    fetch?: (queryParams?: ApiQueryParams<DefaultQueryParams & StepQueryParams>) => Promise<StepListResponse>;
}

export const StepSelect = (props: StepSelectProps) => {
    const { currentAccount } = useAccountRepository();
    const { wizardId } = useParams();
    const [v, cV] = useState<Step | null>(null);
    return (
        <ObjectSelectInput<Step, StepQueryParams>
            {...props}
            id={`${ID}${props.id && '-' + props.id}`}
            label={props.label || CommonMessage.OBJECTS.STEP.DEFAULT}
            className={props.className}
            onChange={(v) => {
                props.onChange && props.onChange(v?.id || null);
                props.onChangeObject && props.onChangeObject(v);
                cV(v);
            }}
            required={props.required}
            queryParams={props.queryParams}
            value={v}
            idValue={props.value || v?.id}
            fetch={props.fetch ? (args) => props.fetch!(args) : (args) => StepClient.fetchSteps(args)}
            itemLabel={(i) => (props.overWriteLabel ? props.overWriteLabel(i) : i.screen + ' - ' + i.trigger + ' - ' + i.next_screen)}
            useQueryParam={
                props.allowURLChange
                    ? {
                        param: 'step',
                        fetch: (args) => StepClient.fetchStep(currentAccount, wizardId!, args)
                    }
                    : undefined
            }
        />
    );
};
